module.exports = __webpack_public_path__ + "img/03_noff_open_L2.6fb6bede.svg";